import Box from '@mui/material/Box';
import { useGlobals } from 'src/shared/contexts/appContext';
import { replaceHelpPageTerms } from 'src/modules/support/helpArticles/functions/helpPageTerms';
import { resolveHelpMediaUrls } from '../functions/resolveHelpMediaUrls';
import { HELP_CALLOUT_BACKGROUND, HELP_CALLOUT_BORDER, HELP_CALLOUT_PADDING } from '../functions/helpCalloutStyle';

type HelpArticleBodyProps = {
  bodyHtml: string;
};

/**
 * En hjälpartikels innehåll med den inloggades benämningar och bilderna från den här miljöns API. Används både i
 * hjälpcentret och i redaktörens förhandsvisning, så att artikeln ser likadan ut före och efter publicering.
 */
export const HelpArticleBody = (props: HelpArticleBodyProps) => {
  const { bodyHtml } = props;
  const { currentUser } = useGlobals();

  return (
    <Box
      sx={{
        overflowWrap: 'anywhere',
        '& img': { maxWidth: '100%', height: 'auto' },
        // Videorna har inga mått i texten och fyller artikelns bredd, även i den smala panelen.
        '& video': { display: 'block', width: '100%', height: 'auto' },
        // Tabeller med fast bredd från editorn rullar i sidled istället för att gå utanför sidan.
        '& table': { borderCollapse: 'collapse', display: 'block', overflowX: 'auto', maxWidth: '100%' },
        '& td, & th': { border: '1px solid', borderColor: 'divider', p: 1 },
        // Citatrutorna går i full bredd, även i den smala panelen. Samma utseende som i editorn.
        '& blockquote': {
          my: 2,
          mx: 0,
          p: HELP_CALLOUT_PADDING,
          backgroundColor: HELP_CALLOUT_BACKGROUND,
          borderLeft: `5px solid ${HELP_CALLOUT_BORDER}`,
        },
        '& blockquote > :first-child': { mt: 0 },
        '& blockquote > :last-child': { mb: 0 },
      }}
      // Innehållet kommer från TinyMCE och skrivs bara av Föreningssupports personal — samma renderingssätt som
      // t.ex. eventDetailTabInformation.tsx.
      dangerouslySetInnerHTML={{ __html: resolveHelpMediaUrls(replaceHelpPageTerms(bodyHtml, currentUser?.mainSettings ?? [])) }}
    />
  );
};
